import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.gray[100],
  flexGrow: 1,
  padding: "30px 0",
  minHeight: "calc(100vh - 200px)",

  [theme.down("sm")]: {
    padding: "15px 0",
  },
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
    gap: 15,
  },

  [theme.down("sm")]: {
    padding: "5px 0",
  },
}));

export const RoutesDataAndFormBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  gap: 20,
  order: 1,

  [theme.down("lg")]: {
    width: "100%",
    order: 2,
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));

// Ширину колонки задаём здесь. Без неё flex-элемент растягивался по самому широкому
// содержимому, и длинный текст внутри (предупреждение о невыписанном билете) раздувал
// колонку, отъедая место у данных заказа слева.
export const PriceAndButtonsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 20,
  order: 2,
  width: 350,
  flexShrink: 0,

  [theme.down("xl")]: {
    width: 320,
  },

  [theme.down("lg")]: {
    width: "100%",
    order: 1,
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));

export const DisclaimerBanner = styled("div")(({ theme }) => ({
  borderRadius: 8,
  overflow: "hidden",
  border: `1px solid ${theme.palette.warning.main}`,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
  marginTop: 8,
}));

export const DisclaimerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  backgroundColor: theme.palette.warning.main,
  height: 46,
  cursor: "pointer",
  padding: "0 16px",
  gap: 10,
  userSelect: "none",

  [theme.down("sm")]: {
    height: 42,
    padding: "0 12px",
  },
}));

export const DisclaimerIcon = styled("span")({
  fontSize: 20,
  lineHeight: 1,
  flexShrink: 0,
});

export const DisclaimerTitle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  fontWeight: 700,
  fontSize: 13,
  color: theme.palette.white,
  letterSpacing: "0.06em",
  textTransform: "uppercase",

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));

export const DisclaimerToggle = styled("div")(({ theme, $isOpen }) => ({
  ...theme.mixins.flexCenterCenter,
  color: theme.palette.white,
  transition: "transform 0.3s ease",
  transform: $isOpen ? "rotate(90deg)" : "rotate(0deg)",
  fontSize: 14,
}));

export const DisclaimerContent = styled("div")(({ theme, $isOpen }) => ({
  backgroundColor: "rgba(37, 99, 235, 0.06)",
  padding: $isOpen ? "16px 20px" : 0,
  maxHeight: $isOpen ? 300 : 0,
  overflow: "hidden",
  transition: "max-height 0.3s ease, padding 0.3s ease",

  [theme.down("sm")]: {
    padding: $isOpen ? "12px 14px" : 0,
  },
}));

export const DisclaimerText = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 13,
  lineHeight: 1.65,
  color: theme.palette.gray[800],

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));

export const PaymentThanks = styled("div")(() => ({
  padding: "16px",
  borderRadius: 8,
  background: "#f0fbf3",
  border: "1px solid #8fd6a5",
  color: "#1d6b35",
  fontSize: 15,
  lineHeight: 1.5,

  "& strong": {
    display: "block",
    fontSize: 17,
    marginBottom: 4,
  },
}));
